module.exports = __webpack_public_path__ + "img/ltkfit-2x.29ed40d.jpg";